/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Target_Preview_PlaceholderInputs */

const en_plain_text_import_target_preview_placeholder = /** @type {(inputs: Plain_Text_Import_Target_Preview_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is how your events will look after import.`)
};

const fr_plain_text_import_target_preview_placeholder = /** @type {(inputs: Plain_Text_Import_Target_Preview_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voici a quoi ressembleront vos evenements apres l'importation.`)
};

const de_plain_text_import_target_preview_placeholder = /** @type {(inputs: Plain_Text_Import_Target_Preview_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So sehen Ihre Ereignisse nach dem Import aus.`)
};

const it_plain_text_import_target_preview_placeholder = /** @type {(inputs: Plain_Text_Import_Target_Preview_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ecco come appariranno i tuoi eventi dopo l'importazione.`)
};

const ru_plain_text_import_target_preview_placeholder = /** @type {(inputs: Plain_Text_Import_Target_Preview_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вот как будут выглядеть ваши события после импорта.`)
};

const es_plain_text_import_target_preview_placeholder = /** @type {(inputs: Plain_Text_Import_Target_Preview_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Así es como se verán tus eventos después de la importación.`)
};

const zh_cn2_plain_text_import_target_preview_placeholder = /** @type {(inputs: Plain_Text_Import_Target_Preview_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导入后，您的事件将如下所示。`)
};

const ja_plain_text_import_target_preview_placeholder = /** @type {(inputs: Plain_Text_Import_Target_Preview_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インポート後のイベントは次のようになります。`)
};

const hi_plain_text_import_target_preview_placeholder = /** @type {(inputs: Plain_Text_Import_Target_Preview_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इंपोर्ट करने के बाद आपके इवेंट इस तरह दिखेंगे।`)
};

const pt_pt2_plain_text_import_target_preview_placeholder = /** @type {(inputs: Plain_Text_Import_Target_Preview_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assim ficarão seus eventos após a importação.`)
};

/**
* | output |
* | --- |
* | "This is how your events will look after import." |
*
* @param {Plain_Text_Import_Target_Preview_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_target_preview_placeholder = /** @type {((inputs?: Plain_Text_Import_Target_Preview_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Target_Preview_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_plain_text_import_target_preview_placeholder(inputs)
	if (locale === "de") return de_plain_text_import_target_preview_placeholder(inputs)
	if (locale === "it") return it_plain_text_import_target_preview_placeholder(inputs)
	if (locale === "ru") return ru_plain_text_import_target_preview_placeholder(inputs)
	if (locale === "es") return es_plain_text_import_target_preview_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_plain_text_import_target_preview_placeholder(inputs)
	if (locale === "ja") return ja_plain_text_import_target_preview_placeholder(inputs)
	if (locale === "hi") return hi_plain_text_import_target_preview_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_plain_text_import_target_preview_placeholder(inputs)
	return en_plain_text_import_target_preview_placeholder(inputs)
});